export default __webpack_public_path__ + "static/media/1.fb21f018.png";